
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Google et Apple`}</strong>{` se sont
`}<a parentName="p" {...{
        "href": "https://techcrunch.com/2020/04/24/apple-and-google-update-joint-coronavirus-tracing-tech-to-improve-user-privacy-and-developer-flexibility/"
      }}>{`inspirées fortement`}</a>{`
des travaux des deux Écoles polytechniques fédérales suisses pour concevoir
leurs interfaces de programmation (API) communes pour le `}<em parentName="p">{`proximity tracing`}</em>{`.
Une fois la mise à jour nécessaire disponibles sur iOS et Android, les
applications compatibles pourront fonctionner sans problème et communiquer entre
elles. Une telle coopération entre les deux géants de la technologie est
historique – les présidents des deux Hautes écoles, Joël Mesot et Martin
Vetterli, n'ont
`}<a parentName="p" {...{
        "href": "https://www.letemps.ch/opinions/lecons-dune-pandemie"
      }}>{`pas caché`}</a>{` leur fierté.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;